import { useEffect, useMemo, useState } from 'react';
import { RootStateOrAny, useDispatch, useSelector } from 'react-redux';
import { getLanguages } from "../../../redux/actions/attributesActions";

type Language = {
  id: number;
  languageId: number;
  text: string;
  code: string;
};

export function usePreloadedTranslations(translations: any[]) {
    const [loading, setLoading] = useState(false);

    const dispatch = useDispatch();

    const { languages } = useSelector((state: RootStateOrAny) => state.AttributesReducer);

    useEffect(() => {
      if (!translations) return;

      if (Object.entries(languages || {}).length) {
        setLoading(false);
        return;
      }

      if (loading) return;

      setLoading(true);
      dispatch(getLanguages);
    }, [translations, loading, setLoading, dispatch, languages])

    const preloadedTranslations = useMemo(() => {
      if (!languages || !translations?.length) return [];

      const { headers, ...rest } = languages;
      const languageList: Language[] = Object.values(rest);
      const hasId = (o: { id?: number }) => !!o.id;
      const reducerFn = (acc: Record<number, Language>, language: Language) => ({ ...acc, [language.id]: language });
      const idIndexedLanguages = languageList.filter(hasId).reduce(reducerFn, {});
      const result = translations.map((t) => ({ id: t.id, language: { code: idIndexedLanguages[t.languageId].code, id: t.languageId }, text: t.text }));
      return result;
    }, [translations, languages]);

    return preloadedTranslations;
}